export function getDarkerShade(color: string): string {
  const hex = color.replace('#', '');
  const r = parseInt(hex.substring(0, 2), 16);
  const g = parseInt(hex.substring(2, 4), 16);
  const b = parseInt(hex.substring(4, 6), 16);
  const darkerR = Math.max(0, Math.floor(r * 0.6));
  const darkerG = Math.max(0, Math.floor(g * 0.6));
  const darkerB = Math.max(0, Math.floor(b * 0.6));
  return `#${darkerR.toString(16).padStart(2, '0')}${darkerG.toString(16).padStart(2, '0')}${darkerB.toString(16).padStart(2, '0')}`;
}

export function getLighterShade(color: string, factor: number = 1.2): string {
  const hex = color.replace('#', '');
  const r = parseInt(hex.substring(0, 2), 16);
  const g = parseInt(hex.substring(2, 4), 16);
  const b = parseInt(hex.substring(4, 6), 16);
  const lighterR = Math.min(255, Math.floor(r * factor));
  const lighterG = Math.min(255, Math.floor(g * factor));
  const lighterB = Math.min(255, Math.floor(b * factor));
  return `#${lighterR.toString(16).padStart(2, '0')}${lighterG.toString(16).padStart(2, '0')}${lighterB.toString(16).padStart(2, '0')}`;
}

export function getColorBrightness(color: string): number {
  const hex = color.replace('#', '');
  const r = parseInt(hex.substring(0, 2), 16);
  const g = parseInt(hex.substring(2, 4), 16);
  const b = parseInt(hex.substring(4, 6), 16);
  return (r * 299 + g * 587 + b * 114) / 1000;
}

export function isRgbColor(color: string): boolean {
  const hex = color.replace('#', '');
  const r = parseInt(hex.substring(0, 2), 16);
  const g = parseInt(hex.substring(2, 4), 16);
  const b = parseInt(hex.substring(4, 6), 16);
  const maxChannel = Math.max(r, g, b);
  const minChannel = Math.min(r, g, b);
  const isBlackLike = maxChannel < 60 && maxChannel - minChannel < 30;
  if (isBlackLike) return false;
  const isRedDominant = r > g * 1.3 && r > b * 1.3;
  const isGreenDominant = g > r * 1.3 && g > b * 1.3;
  const isBlueDominant = b > r * 1.3 && b > g * 1.3;
  return isRedDominant || isGreenDominant || isBlueDominant;
}

export function getDarkestRgbColor(colors: string[]): string {
  const rgbColors = colors.filter(isRgbColor);
  if (rgbColors.length === 0) {
    const nonBlackColors = colors.filter(color => {
      const hex = color.replace('#', '');
      const r = parseInt(hex.substring(0, 2), 16);
      const g = parseInt(hex.substring(2, 4), 16);
      const b = parseInt(hex.substring(4, 6), 16);
      return Math.max(r, g, b) >= 60;
    });
    if (nonBlackColors.length > 0) {
      return nonBlackColors.reduce(
        (darkest, current) => (getColorBrightness(current) < getColorBrightness(darkest) ? current : darkest),
        nonBlackColors[0],
      );
    }
    return colors[0];
  }
  return rgbColors.reduce(
    (darkest, current) => (getColorBrightness(current) < getColorBrightness(darkest) ? current : darkest),
    rgbColors[0],
  );
}
